import axios from 'axios';
import { API_URL } from './config/constant.js'

const customAxios = axios.create({
    baseURL: API_URL,
    timeout: 30000
});

const requestHandler = request => {
    let token = localStorage.getItem("token");
    if(token){
        request.headers.Authorization = `Bearer ${token}`;  
    }
    return request;
};

const responseHandler = response => {
    if (response.status === 403) {
        localStorage.clear()
    }
    return response;
};

const errorHandler = async error => {   
    let err= {
        message: '',
        status: error.response.status
    }
    if (error.response) {
        err.message= JSON.stringify(error.response.data)
        if(error.response.status === 403 || error.response.data.message === 'Unauthenticated.'){
            localStorage.clear()
        }
        if(error.response.data.message){
            err.message = error.response.data.message
        }
        return Promise.reject(err);
    } else if (error.request) {
        err.message = JSON.stringify(error.request);
    } else {
        err.message = error.message;
    }
    return Promise.reject(err);
};

customAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
 );

export default customAxios;